import axios from "../utils/axios";

export function changeTicketStep(data) {
  return axios.post("/TicketStep/ChangeTicketStep", data);
}
